import axios from 'axios'
import { baseURL } from '../utils/baseURL'

const axiosBackendInstance = (env: string) => {
	return axios.create({
		baseURL: baseURL(env, true),
		withCredentials: true,
	})
}

export default axiosBackendInstance
